/* Dialog Text */
import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import { InteractSubTypes } from "../../../api/models";

export interface EditSubLevelsDialogData {
  dialogTitle: string;
  isNew: boolean;
  interactSubTypes: InteractSubTypes[];
  subscriptionLevelId: number;
  subscriptionTypeId: number;
  description: string;
  maxAdminUsers: number;
  maxDesignerUsers: number;
  maxDashboardUsers: number;
  maxReportUsers: number;
  allowDownload: boolean;
  allowPurchase: boolean;
  allowModify: boolean;
  allowInvoice: boolean;
  allowPreFilter: boolean;
  hasApiAccess: boolean;
  unlimitedDataSetData: boolean;
  unlimitedSourceData: boolean;
  monthlyDataSetDataRows: number;
  monthlySourceDataRows: number;
  allowPrintOnDemand: boolean;
  allowDataOnDemand: boolean;
  hasAiChatAccess: boolean;
  monthlyMaxTokens: number;
}

@Component({
  selector: "edit-subscription-level-dialog",
  styleUrls: ["edit-subscription-level-dialog.component.css"],
  templateUrl: "./edit-subscription-level-dialog.component.html",
})
export class EditSubLevelsDialogComponent {
  public Result: DialogResult;

  constructor(
    public dialogRef: MatDialogRef<EditSubLevelsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditSubLevelsDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.data;
    this.dialogRef.close(this.Result);
  }
}

/* Calling Methods */
/*
  callEditSubLevels(params: EditSubLevelsDialogData) {
    var dialogRef = this.dialog.open(EditSubLevelsDialogComponent, {
      width: '500px',
      data: params
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result != null && result.ResultType != null && result.ResultType == DialogResultType.Ok) {
        //Do something here!
      }
    });
  }
*/
